import { SearchFilterValues } from 'interfaces/searchFilter'

const KEY = 'orders:list:filter'

/**
 * Persists the orders-list filter in sessionStorage so it survives navigation
 * (e.g. going into an order detail and back). Dates are not persisted: the
 * date range is transient and the stored shape stays JSON-safe.
 */
export const ordersFilterStorage = {
    load(): SearchFilterValues | null {
        try {
            const raw = sessionStorage.getItem(KEY)
            if (!raw) return null
            const parsed = JSON.parse(raw) as Omit<SearchFilterValues, 'date'>
            return { ...parsed, date: { start: null, end: null } }
        } catch {
            return null
        }
    },

    save(filter: SearchFilterValues): void {
        try {
            // date is excluded on purpose (not JSON-serializable in a useful way)
            const { search, states, classificationTypeId, classificationTypeCode, withoutContainerization } = filter
            sessionStorage.setItem(
                KEY,
                JSON.stringify({ search, states, classificationTypeId, classificationTypeCode, withoutContainerization })
            )
        } catch {
            // sessionStorage unavailable: persistence is best-effort
        }
    },

    clear(): void {
        try {
            sessionStorage.removeItem(KEY)
        } catch {
            // no-op
        }
    },
}
